<template>
  <v-link
    :to="to"
    class="v-block-link d-flex align-items-center"
    v-on="$listeners"
  >
    <slot></slot>
  </v-link>
</template>

<script>
export default {
  props: {
    to: { type: String, default: null }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.v-block-link {
  background: $color-ui--white;
  border-radius: var(--border-radius);
  box-shadow: $box-shadow--medium;
  color: $color-ui--black;
  font-weight: $font-weight--semi-bold;
  font-family: var(--body-font-stack);
  font-size: $font-size--base;

  .v-icon {
    transform: scale(1.4);
    color: $color-ui--grey-80;
  }
}
</style>
